<div class="QualityScoreRow" popoverClass="quality-score" #pop="ngbPopover" (mouseover)="pop.open()"
(mouseleave)="pop.close()" placement="bottom" container="body" [ngbPopover]="popoverContent">
    <div class="QualityScoreCircle" [ngClass]="color">
        <svg viewBox="0 0 41 22" style="width: 100%;">
            <text x="50%" y="50%" text-anchor="middle">{{ formatNumber(value) }}</text>
        </svg>
    </div>
</div>
<ng-template #popoverContent>
    <ng-container *ngIf="tooltipValues.isTeam">
        <div>{{getLocaleText('Team', 'Team')}}: <span>{{tooltipValues.Group.groupName}}</span></div>
        <div>{{getLocaleText('Average_Team_Score', 'Avg. Team Score')}}: <span>{{formatNumber(tooltipValues.MetricData.MetricDisplayValue)}}</span></div>
        <div *ngIf="tooltipValues?.Agents !== null && tooltipValues?.Agents >= 0">{{getLocaleText('Number_Of_Agents', 'Number of
            Agents')}}: <span>{{tooltipValues.Agents}}</span></div>
        <div *ngIf="tooltipValues?.Evaluations !== null && tooltipValues?.Evaluations >= 0">{{getLocaleText('Number_Of_Evaluations', 'Number of
            Evaluations')}}: <span>{{tooltipValues.Evaluations}}</span></div>
    </ng-container>
    <ng-container *ngIf="!tooltipValues.isTeam">
        <div>{{getLocaleText('Agent', 'Agent')}}: <span>{{tooltipValues.Group.groupName}}</span></div>
        <div>{{getLocaleText('Average_Agent_Score', 'Avg. Agent Score')}}: <span>{{formatNumber(tooltipValues.MetricData.MetricDisplayValue)}}</span></div>
        <div *ngIf="tooltipValues?.Evaluations !== null && tooltipValues?.Evaluations >= 0">{{getLocaleText('Number_Of_Evaluations', 'Number of
            Evaluations')}}: <span>{{tooltipValues.Evaluations}}</span></div>
        <div *ngIf="tooltipValues?.Variance !== null">{{getLocaleText('Variance', 'Variance')}}: <span>{{formatNumber(tooltipValues.Variance)}}</span></div>
    </ng-container>
</ng-template>